module.exports = __webpack_public_path__ + "static/media/la_freccia_azzurra.0f55e45a.gif";